import { styled } from 'styled-components';

export const ModalRoot = styled.div<{
  $mounted: boolean;
  $shouldScroll?: boolean;
}>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(76, 86, 103, 0.3);
  z-index: 10002;
  transition: opacity 0.25s ease-in-out;
  cursor: pointer;
  overflow: auto;
  padding: 5rem 2rem;
  backdrop-filter: blur(0.15rem);
  display: ${props => (props.$mounted ? 'flex' : 'none')};
  align-items: center;
  overflow-x: hidden;
`;

ModalRoot.defaultProps = { $mounted: false };

export const ModalContainer = styled.div<{
  $width?: string;
  $maxHeight?: string;
  $backgroundColor?: string;
  $activateAnimation?: boolean;
}>`
  background-color: ${props =>
    props.$backgroundColor ? props.$backgroundColor : props.theme.color.white};
  max-height: ${({ $maxHeight }) => $maxHeight};
  width: ${({ $width }) => $width};
  border-top-left-radius: ${({ theme }) => theme.borderRadius.radius20};
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius.radius20};
  cursor: auto;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  position: absolute;
  right: ${({ $activateAnimation }) => ($activateAnimation ? '0' : '-44rem')};
  transition: right 1000ms ease-in-out;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    width: 100%;
  }
`;
ModalContainer.defaultProps = { $width: '43.5rem' };

export const CloseIcon = styled.div`
  display: flex;
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  cursor: pointer;
`;
